<div class="containerWrapper">
  <h1>{{ 'Add New Subscriber' | translate }}</h1>
  <div class="productDetail">
    <mat-progress-bar mode="indeterminate" *ngIf="subscriberProgress"></mat-progress-bar>
    <div class="productHeader">
      <h1>{{ 'SUBSCRIBERS' | translate }}</h1>
      <button [routerLink]="['/admin/subList']">{{ 'SEE ALL Subscribers' | translate }}</button>
    </div>
    <form [formGroup]="subscriberForm" (ngSubmit)="onSubmit()">
      <div class="productForm">
        <div class="left">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Subscriber Name' | translate }}</mat-label>
            <input required matInput formControlName="subscriberName" [(ngModel)]="subscriberName" />
            <mat-error> {{ 'Subscriber Name is required' | translate }} </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Subscriber Email' | translate }}</mat-label>
            <input type="email" required matInput formControlName="subscriberEmail" [(ngModel)]="subscriberEmail" />
            <mat-error> {{ 'Subscriber Email is required' | translate }} </mat-error>
          </mat-form-field>

          <label>{{ 'Subscriber Notes' | translate }}</label>
          <editor
            formControlName="notes"
            [(ngModel)]="notes"
            apiKey="dh6nv3idqamf38bn1tnknqxd0qn9vz2yli1zjpjehily2stk"
            [init]="{
              base_url: '/tinymce',
              suffix: '.min',
              height: 320,
              menubar: false,
              plugins: ['lists', 'help', 'textcolor', 'colorpicker', 'code'],
              toolbar:
                'code | undo redo | bold italic | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent forecolor backcolor | help'
            }"
          ></editor>
        </div>
        <div class="right">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Subscription Price' | translate }}</mat-label>
            <input required type="number" min="0" matInput formControlName="subscriptionPrice" [(ngModel)]="subscriptionPrice" />
            <mat-error> {{ 'Subscription Price is required' | translate }} </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Subscription Currency' | translate }}</mat-label>
            <mat-select formControlName="currency" [(ngModel)]="currency">
              <mat-option value="EGP"> {{ 'EGP' | translate }} </mat-option>
              <mat-option value="Dollar"> {{ 'Dollar' | translate }} </mat-option>
              <mat-option value="Euro"> {{ 'Euro' | translate }} </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Subscription Plan' | translate }}</mat-label>
            <input required matInput formControlName="subscriptionPlan" [(ngModel)]="subscriptionPlan" />
            <mat-error> {{ 'Subscription Plan is required' | translate }} </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Renewal Date' | translate }}</mat-label>
            <input required type="date" matInput formControlName="renewalDate" [(ngModel)]="renewalDate" />
            <mat-error> {{ 'Renewal Date is required' | translate }} </mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Status' | translate }}</mat-label>
            <mat-select (selectionChange)="statusChange($event.value)" formControlName="status" [(ngModel)]="status">
              <mat-option value="active"> {{ 'Active' | translate }} </mat-option>
              <mat-option value="onhold"> {{ 'Onhold' | translate }} </mat-option>
              <mat-option value="cancelled"> {{ 'Cancelled' | translate }} </mat-option>
              <mat-option value="refund"> {{ 'Refund' | translate }} </mat-option>
            </mat-select>
            <mat-error> {{ 'Status is required' | translate }} </mat-error>
          </mat-form-field>
          <div class="actionBtnsWrapper">
            <button mat-icon-button class="stacksBtn green" type="button" (click)="createProject()">
              <span>{{ 'Create Project' | translate }}</span>
            </button>
            <button mat-icon-button class="stacksBtn blue" type="submit">
              <span>{{ 'PUBLISH' | translate }}</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
